
export const MyBillingPlans = {
    monthly: {
        FREE: 0,
        STARTER: 7.99,
        PRO: 19.99,
        ULTRA: 29.99,
    },
    yearly: {
        FREE: 0,
        STARTER: 80.69,
        PRO: 201.59,
        ULTRA: 302.39,
    },
    regular: {
        FREE: 0,
        STARTER: 15.99,
        PRO: 29.99,
        ULTRA: 39.99,
    },
};
